import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { Star } from "@element-plus/icons-vue";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
export default {
  props: ["paperInfo", "itemNo", "answers", "examType", "fastTime", "isLineType", "menuRe", "vsptLoading"],
  setup(props, content) {
    let route = useRoute();
    let taskNo = ref(-1);
    let preTotalNo = ref(0);
    let menuList = computed(() => {
      let list = [];
      if (props.paperInfo.items) {
        let task = 0;
        props.paperInfo.items.forEach((item, index) => {
          if (index == props.itemNo && taskNo.value == -1) {
            taskNo.value = task;
          }
          if (item.questionGroupList) {
            item.questionGroupList.forEach(taskItem => {
              taskItem.questionList.forEach(questionItem => {
                if (questionItem.questionScore || props.paperInfo.skill == "S5") {
                  if (props.answers && props.answers[questionItem.questionId]) {
                    list.push({
                      taskNo: task,
                      itemNo: index,
                      isFinish: true
                    });
                  } else {
                    list.push({
                      taskNo: task,
                      itemNo: index,
                      isFinish: false
                    });
                  }
                  task++;
                }
              });
            });
          }
        });
      }
      content.emit("setTotalNo", list.length);
      return list;
    });
    // 设置前卷题数
    function setPreTotalNo() {
      if (props.examType == 3 && (route.query.examid || route.query.examId) || (route.query.examid || route.query.examId) && route.meta.skill == "S0") {
        if (window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId))) {
          preTotalNo.value = Number(window.localStorage.getItem("preTotalNo-" + (route.query.examid || route.query.examId)));
        }
      }
    }
    setPreTotalNo();
    function change(msg) {
      if (msg.taskNo != taskNo.value) {
        if (msg.itemNo != props.itemNo) {
          if (props.paperInfo.items[props.itemNo].isFast) {
            //计算未作答题目
            let num = props.paperInfo.items[0].questionGroupList.length;
            for (let key in props.answers) {
              if (props.answers[key] && props.answers[key] !== "") {
                num--;
              }
            }
            ElMessageBox.confirm(`本部分提交后不能返回修改${num > 0 ? "(" + num + "题未作答)" : ""},确认提交吗？`, "", {
              showClose: false,
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              taskNo.value = msg.taskNo;
              content.emit("changeItem", msg.itemNo);
            }).catch(() => {});
          } else if (props.paperInfo.items[msg.itemNo].isFast) {
            ElMessageBox.confirm(`该部分提交后不能返回修改`, "", {
              showClose: false,
              showCancelButton: false,
              cancelButtonText: false,
              type: "warning"
            });
          } else {
            taskNo.value = msg.taskNo;
            content.emit("changeItem", msg.itemNo);
          }
        } else {
          taskNo.value = msg.taskNo;
        }
      }
    }
    //下一题
    function next() {
      //已经最后一题
      if (menuList.value[menuList.value.length - 1].itemNo == props.itemNo) {
        if (props.examType == 3) {
          return 0;
        } else {
          window.localStorage.setItem("preTotalNo-" + (route.query.examid || route.query.examId), menuList.value.length);
          content.emit("changePaper");
          return 0;
        }
      }
      for (let i = taskNo.value + 1; i < menuList.value.length; i++) {
        if (menuList.value[i].itemNo != props.itemNo) {
          if (props.paperInfo.items[props.itemNo].isFast) {
            let num = props.paperInfo.items[0].questionGroupList.length;
            for (let key in props.answers) {
              if (props.answers[key] && props.answers[key] !== "") {
                num--;
              }
            }
            ElMessageBox.confirm(`本部分提交后不能返回修改${num > 0 ? "(" + num + "题未作答)" : ""},确认提交吗？`, "", {
              showClose: false,
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              taskNo.value = menuList.value[i].taskNo;
              content.emit("changeItem", menuList.value[i].itemNo);
            });
          } else {
            taskNo.value = menuList.value[i].taskNo;
            content.emit("changeItem", menuList.value[i].itemNo);
          }
          break;
        }
      }
    }
    //上一题
    function back() {
      //已经一题
      if (menuList.value[0].itemNo == props.itemNo) return 0;
      for (let i = taskNo.value - 1; i >= 0; i--) {
        if (menuList.value[i].itemNo != props.itemNo) {
          if (props.paperInfo.items[menuList.value[i].itemNo].isFast) {
            ElMessageBox.confirm(`本部分提交后不能返回修改`, "", {
              showClose: false,
              showCancelButton: false,
              cancelButtonText: false,
              type: "warning"
            });
          } else {
            taskNo.value = menuList.value[i].taskNo;
            content.emit("changeItem", menuList.value[i].itemNo);
          }
          break;
        }
      }
    }
    watch(() => props.menuRe, () => {
      if (props.menuRe || props.menuRe == 0) {
        setPreTotalNo();
        taskNo.value = props.menuRe;
      }
    });
    watch(() => props.fastTime, () => {
      if (props.fastTime == 0) {
        for (let i = taskNo.value + 1; i < menuList.value.length; i++) {
          if (menuList.value[i].itemNo != props.itemNo) {
            taskNo.value = menuList.value[i].taskNo;
            content.emit("changeItem", menuList.value[i].itemNo);
            ElMessage({
              type: "warning",
              showClose: true,
              message: `快速阅读结束`
            });
            break;
          }
        }
      }
    });
    return {
      preTotalNo,
      Star,
      menuList,
      taskNo,
      change,
      next,
      back
    };
  }
};